import { recommendations } from "@api/index";
import { RecommendedConditions } from "@types-runway/case";
import { Gender } from "@types-runway/user";
import { mapConditionPrescriptions } from "@utils/case/conditionPrescriptions";
import { RECOMMENDATION_TIMEOUT_MS } from "@utils/constantsEnv";

const useComfortCare = () => {
  const getComfortCare = async (
    tripDescription: string,
    userGender: Gender
  ): Promise<RecommendedConditions> => {
    try {
      const { data } = await recommendations.recommendationPost(
        "/comfort-care",
        {
          tripDescription,
          userGender,
        },
        { timeout: RECOMMENDATION_TIMEOUT_MS }
      );
      const mappedConditions = await mapConditionPrescriptions(data.conditions, 0);

      return {
        ...data,
        conditions: mappedConditions,
      };
    } catch (error) {
      return {
        conditions: [],
        reason: "",
      };
    }
  };
  return { getComfortCare };
};

export default useComfortCare;
